import { EpicIcons } from "@constellation-academy/epic-ui";
import { confirmDialog } from "primereact/confirmdialog";
import { useMutation } from "react-relay";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { resendActivationMailButton_TriggerResendActivationMutation } from "@relay/resendActivationMailButton_TriggerResendActivationMutation.graphql";
import { TRIGGER_RESEND_ACTIVATION_MUTATION } from "./resend-activation-mail-button.graphql";
import { ResendActivationMailButtonProps } from "./resend-activation-mail-button.types";
import { Button } from "../../../../components/button";

export const ResendActivationMailButton = ({ userId }: ResendActivationMailButtonProps) => {
	const { t } = useTranslation("common");
	const [triggerResendActivation, isResendingActivation] =
		useMutation<resendActivationMailButton_TriggerResendActivationMutation>(
			TRIGGER_RESEND_ACTIVATION_MUTATION,
		);

	const handleOnResendActivation = () => {
		confirmDialog({
			header: t("userEdit.resendActivationMail"),
			message: t("userEdit.resendActivationMailConfirmMessage"),
			icon: "pi pi-info-circle",
			acceptLabel: t("actions.yes"),
			rejectLabel: t("actions.no"),
			accept: () =>
				triggerResendActivation({
					variables: {
						input: {
							userId,
						},
					},
					onCompleted: () => {
						toast.success(t("userEdit.activationMailSent"));
					},
				}),
		});
	};

	return (
		<>
			<Button
				icon={EpicIcons.ENVELOPE}
				label={t("userEdit.resendActivationMail")}
				onClick={handleOnResendActivation}
				disabled={isResendingActivation}
			/>
		</>
	);
};
